// The menu waits 10ms for layout, then writes style.top. The element can
// unmount in that gap, and `menu.style` throws `reading 'style'` of null.

export function applyContextMenuPosition(menu, normalizedX, normalizedY) {
    if (menu == null) return false;
    menu.style.top = `${normalizedY}px`;
    menu.style.left = `${normalizedX}px`;
    return true;
}
